export default __webpack_public_path__ + "static/bg-page-music-b98029b74a4ad5afdaee827d1ee63518.jpg";